import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { FeedInsertsListItem } from "../../content.types";

export const requestFeedInserts = async (
  params: GetListRequestParams
): Promise<GetListResponse<FeedInsertsListItem>> => {
  return await instance.get(ApiRoutesContent.FeedInserts, { params });
};
